import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_component_van_tabbar, {
    key: 0,
    route: "",
    "z-index": "99",
    placeholder: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      to: "/index",
      icon: "home-o"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("首页")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      to: "/goods",
      icon: "bag-o"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("商品")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      to: "/cart",
      badge: $setup.cartNo,
      icon: "cart-o"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("购物车")])),
      _: 1
    }, 8, ["badge"]), _createVNode(_component_van_tabbar_item, {
      to: "/user",
      icon: "user-o"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("我的")])),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)], 64);
}